// Hook (use-auth.js) (https://usehooks.com/)
import React, { useState, useEffect, useContext, createContext } from "react";


import Request from './Request';
import {Paths} from './Constants';
import Cookies from 'js-cookie';


const authContext = createContext();
// Provider component that wraps your app and makes auth object ...
// ... available to any child component that calls useAuth().
export function ProvideAuth({ children }) {
  const auth = useProvideAuth();
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}
// Hook for child components to get the auth object ...
// ... and re-render when it changes.
export const useAuth = () => {
  return useContext(authContext);
};

// Provider hook that creates auth object and handles state
function useProvideAuth() {
  const [user, setUser] = useState(null);
  const [redirectUrl, setRedirectUrl] = useState(null);

  // Wrap any Firebase methods we want to use making sure ...
  // ... to save the user to state.
  const signin = async (email, password) => {
    var result = await Request.Post(Paths.Login, { Username: email, Password: password, RememberMe :  true  });
    if (result.ok){
        console.log(result.data);
        Request.StoreAccessToken(result.data.AccessToken);
        Request.StoreRefreshToken(result.data.RefreshToken);
        setUser(result.data.User);
        return result.data.User;
    }
    else{
      return false;
    }
    
    // return firebase
    //   .auth()
    //   .signInWithEmailAndPassword(email, password)
    //   .then((response) => {
    //     setUser(response.user);
    //     return response.user;
    //   });
  };

  const signup = async (email, password, username, firstname, lastname, culturecode) => {
    var result = await Request.Post(Paths.Register, { Email: email, Password: password, Username : username, FirstName : firstname, LastName : lastname, CultureCode : culturecode  });
    if (result.ok){
        console.log(result.data);
        Request.StoreAccessToken(result.data.AccessToken);
        Request.StoreRefreshToken(result.data.RefreshToken);
        setUser(result.data.User);
        return result.data.User;
    }
    else{
      return false;
    }
  };
  const signout = async () => {

    Request.RemoveTokens();
    setUser(false);

  };
  const sendPasswordResetEmail = (email) => {
    // return firebase
    //   .auth()
    //   .sendPasswordResetEmail(email)
    //   .then(() => {
    //     return true;
    //   });
  };
  const confirmPasswordReset = (code, password) => {
    // return firebase
    //   .auth()
    //   .confirmPasswordReset(code, password)
    //   .then(() => {
    //     return true;
    //   });
  };
  // Subscribe to user on mount
  // Because this sets state in the callback it will cause any ...
  // ... component that utilizes this hook to re-render with the ...
  // ... latest auth object.
  useEffect(async () => {
    // const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
    //   if (user) {
    //     setUser(user);
    //   } else {
    //     setUser(false);
    //   }
    // });
    // // Cleanup subscription on unmount
    // return () => unsubscribe();
  
    if (Request.TokensAvailable()){
      
          var req = await Request.Get(Request.Paths.User);
        if (req.ok){
            // setUserName(user.data.name);
            // setIsAuthenticated(true);
            setUser(req.data);
            console.log(req.data);
        }
        else
        {
            Request.RemoveTokens();
            setUser(false);
        
        }
    }
    else{
        Request.RemoveTokens();
        setUser(false);
    
    }
  }, []);
  // Return the user object and auth methods
  return {
    user,
    signin,
    signup,
    signout,
    sendPasswordResetEmail,
    confirmPasswordReset,
    redirectUrl,
    setRedirectUrl
  };
}